import { Waypoint } from '@omniafishing/core';
import dayjs from 'dayjs';
import React from 'react';
import { WaypointMarker } from '../../waypoint_marker';
import styles from './waypoint_card.less';
import { WaypointMoreButton } from './waypoint_more_button';

interface WaypointCardProps {
  onEditableWaypointChange: (waypoint: Waypoint | null, flyTo?: boolean) => void;
  onSelectedWaypointChange: (waypoint: Waypoint) => void;
  onWaypointDelete: (waypointId: number) => void;
  waypoint: Waypoint;
}

export const areWaypointDatesSame = (waypoint: Waypoint) => {
  const { outing_at, created_at } = waypoint;
  const outingDate = dayjs(outing_at).format('YYYY-MM-DD');
  const createdAt = dayjs(created_at).format('YYYY-MM-DD');
  return outingDate === createdAt;
};

export const getWaypointDateToDisplay = (waypoint: Waypoint) => {
  const { outing_at } = waypoint;
  return `${dayjs(outing_at).format('MMM D, YYYY')} at ${dayjs(outing_at).format('h:mm A')}`;
};

export const WaypointCard = React.memo((props: WaypointCardProps) => {
  const { onEditableWaypointChange, onSelectedWaypointChange, onWaypointDelete, waypoint } = props;
  const { name, waterbody, waypoint_type, symbol_imported } = waypoint;

  return (
    <li
      className={styles.waypointItem}
      onClick={() => {
        onSelectedWaypointChange(waypoint);
      }}
    >
      <span className={styles.waypointType}>
        <WaypointMarker waypoint_type={waypoint_type} />
      </span>
      <div className={styles.waypointDetails}>
        <strong className="flex gap-1">
          <span>{name}</span>
          {symbol_imported && <span className="text-[#657d7d]">({symbol_imported})</span>}
        </strong>
        {waterbody && (
          <span className={styles.waypointDetailsSecondaryInfo}>{waterbody.primary_name}</span>
        )}
        <span className={styles.waypointDetailsSecondaryInfo}>
          {getWaypointDateToDisplay(waypoint)}
        </span>
      </div>
      <div className={styles.moreButton}>
        <WaypointMoreButton
          waypoint={waypoint}
          onEditableWaypointChange={onEditableWaypointChange}
          onWaypointDelete={onWaypointDelete}
        />
      </div>
    </li>
  );
});
